import { useQuery } from '@tanstack/react-query'
import axiosClient from '../../config/api/axios'
import { getAccessToken } from '@/config/api/authStore'
import {
  getWhoamiPath,
  isApiConfigured,
  isAuthDevBypass,
  isCredentialsRequired,
} from '@/config/api/env'
import { queryKeys } from '@/query/queryKeys'

export const whoamiQueryKey = queryKeys.auth.whoami
const WHOAMI_TIMEOUT_MS = 15_000

/**
 * Validates session against GET /api/me (or VITE_AUTH_WHOAMI_PATH).
 * Enabled when API is configured and a bearer token or cookie session is expected.
 */
export function useWhoami() {
  const hasToken = Boolean(getAccessToken())
  const enabled =
    !isAuthDevBypass() &&
    isApiConfigured() &&
    (hasToken || isCredentialsRequired())

  return useQuery({
    queryKey: whoamiQueryKey,
    queryFn: async ({ signal }) => {
      const { data } = await axiosClient.get(getWhoamiPath(), {
        signal,
        timeout: WHOAMI_TIMEOUT_MS,
      })
      return data
    },
    enabled,
    retry: false,
    staleTime: 60_000,
  })
}

/** @param {import('@tanstack/react-query').UseQueryResult} whoamiQuery */
export function isWhoamiAuthenticated(whoamiQuery) {
  if (isAuthDevBypass()) return true
  if (!isApiConfigured()) return true
  if (!whoamiQuery.isEnabled) {
    return Boolean(getAccessToken())
  }
  return whoamiQuery.isSuccess
}
